import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { UserPlus, FileText, CreditCard } from "lucide-react";
import { PageHeader, Spinner, Card, EmptyState } from "./_ui";

const ICONS = { "user-plus": UserPlus, "file-text": FileText, "credit-card": CreditCard };

export default function ActivitePanel() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/admin/activity").then((r) => setItems(r.data)); }, []);
  if (!items) return (<><PageHeader title="Activité" /><Spinner /></>);

  return (
    <div data-testid="admin-activity">
      <PageHeader
        title="Activité"
        subtitle="Journal en temps réel des actions sur la plateforme A.F.B."
      />
      {items.length === 0 ? (
        <EmptyState icon={FileText} title="Aucune activité enregistrée" />
      ) : (
        <Card className="p-2">
          <div className="divide-y divide-white/5">
            {items.map((a, i) => {
              const Icon = ICONS[a.icon] || FileText;
              const color = a.type === "user" ? "#34D399" : a.type === "payment" ? "#D4AF37" : "#7AB0FF";
              return (
                <div key={i} className="flex items-start gap-4 px-4 py-3.5">
                  <div className="w-9 h-9 rounded-lg grid place-items-center shrink-0"
                    style={{ background: `${color}1A`, color }}>
                    <Icon size={16} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="text-sm text-white">{a.title}</div>
                    <div className="text-xs text-slate-400 mt-0.5">{a.subtitle}</div>
                  </div>
                  <div className="text-xs text-slate-500 shrink-0">
                    {a.at ? new Date(a.at).toLocaleString("fr-FR") : "—"}
                  </div>
                </div>
              );
            })}
          </div>
        </Card>
      )}
    </div>
  );
}
